import { Element } from 'slate';
import { isReferenceTable } from './reference-table';
import { ReferenceTable } from 'app/slate/components/ReferenceTable';
import { TaggableTable } from '../components/TaggableTable';
import { useEditorMode } from 'app/state/contexts/EditorContext';

const isImportArea = (node) => Element.isElement(node) && node.type === 'import-area';

const TableRenderer = ({ props, withComments, withTags, readOnly }) => {
  const { isTaggingMode } = useEditorMode();

  if (isTaggingMode) {
    return <TaggableTable {...props} withComments={withComments} withTags={withTags} />;
  }
  return <ReferenceTable {...props} readOnly={readOnly} />;
};

const importArea =
  (options = {}) =>
  (editor) => {
    const { isVoid, renderElement } = editor;
    const withComments = options.withComments ?? false;
    const withTags = options.withTags ?? false;
    editor.isVoid = (element) => isImportArea(element) || isReferenceTable(element) || isVoid(element);

    editor.renderElement = (props) => {
      if (isReferenceTable(props.element)) {
        return <TableRenderer props={props} withComments={withComments} withTags={withTags} readOnly={options.readOnly} />;
      } else {
        return renderElement(props);
      }
    };

    return editor;
  };

export default importArea;
